import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const WarningSnackbar = ({ open, message, onClose }) => {
    return (
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={onClose} severity="warning" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    );
  };
  
  export default WarningSnackbar;